import EmptyIllustration from 'common/assets/empty-illustration';
import { themedStyled } from 'common/styles/styletron.theme';
import Text from 'components/elements/text';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import Separator from './separator';

export default function EmptyView() {
  const { t } = useTranslation();
  return (
    <Container>
      <Content>
        <EmptyIllustration size="100%" style={{ maxWidth: 200 }} />
        <Separator gap={48} />
        <Text variant="HeadingSmall">{t('common:nothing_here')}</Text>
        <Separator gap={12} />
        <Text variant="ParagraphMedium">
          {t('common:you_have_no_data_at_this_moment')}
        </Text>
      </Content>
    </Container>
  );
}

const Container = themedStyled('div', {
  display: 'flex',
  height: '100%',
  width: '100%',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

const Content = themedStyled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});
